import React from "react";
import Table from "../../../components/Table";
import Button from "../../../components/Button";
import InputField from "../../../components/InputField";
import SelectField from "../../../components/SelectField";
import { useLocalization } from "../../../../context/LocalizeContextProvider";
import { Link } from "react-router-dom";
// import { useModal } from "../../../../context/ModalProvider";
import { formatNumberWithCurrency } from "../../../../utils/utils";

export default function ItemComponent({
  dataItem,
  isLoading,
  mutateDelete,
  totalPage = 0,
  totalEntries = 0,
  sizePerPage = 0,
  handleSetSizePerPage,
  handlePagination,
  activePage,
  sortState,
  setSortState,
  searchInput = "",
  setSearchInput = () => undefined,
  categoryItemId = "",
  setCategoryItemId = () => undefined,
  dataCategoryItem = [],
}) {
  const localize = useLocalization();
  // const modal = useModal();

  const columns = [
    { label: localize.getText("id"), isSort: true, key: "id" },
    { label: localize.getText("name"), isSort: true, key: "name" },
    { label: localize.getText("price"), isSort: true, key: "price" },
    { label: localize.getText("category-item"), isSort: true, key: "category" },
    { label: "Status", key: "active", className: "text-center" },
    {
      label: localize.getText("action"),
      className: "text-center",
      style: { width: "200px" },
    },
  ];
  return (
    <div className="card">
      <div className="card-header d-flex flex-wrap gap-2 align-items-end justify-content-between">
        <div className="d-flex flex-wrap gap-2 align-items-end">
          <div style={{ minWidth: 240 }}>
            <InputField
              label={localize.getText("search")}
              placeholder={localize.getText("search")}
              value={searchInput}
              onChange={(v) => setSearchInput(v ?? "")}
              size="small"
            />
          </div>
          <div style={{ minWidth: 220 }}>
            {/* TODO: swap to async searchable combobox when tenants exceed 500 categories */}
            <SelectField
              label={localize.getText("category-item")}
              placeholder={localize.getText("allCategories")}
              value={categoryItemId}
              onChange={(v) => setCategoryItemId(v || "")}
              data={[
                { id: "", name: localize.getText("allCategories") },
                ...dataCategoryItem,
              ]}
              valueKey="id"
              labelKey="name"
              size="small"
            />
          </div>
        </div>
        <Link to="/item/add-item">
          <Button label={localize.getText("addItem")} size="btn-sm" />
        </Link>
      </div>
      <div className="card-body">
        <Table
          columns={columns}
          loading={isLoading}
          activePage={activePage}
          totalPage={totalPage}
          totalShow={dataItem.length}
          totalEntries={totalEntries}
          handlePagination={handlePagination}
          sizePerPage={sizePerPage}
          handleSizePerPage={handleSetSizePerPage}
          sortState={sortState}
          setSortState={setSortState}
        >
          {dataItem.map((item, index) => (
            <tr key={index}>
              <td className="sorting_1">{item.id}</td>
              <td>{item.name}</td>
              <td>{formatNumberWithCurrency(item.price)}</td>
              <td>{item.category_name}</td>
              <td className="text-center">
                <span
                  className={`badge ${
                    item.active ? "badge-success" : "badge-danger"
                  }`}
                  style={{ fontSize: "12px", padding: "6px 12px" }}
                >
                  {item.active ? "Aktif" : "Non Aktif"}
                </span>
              </td>
              <td>
                <div className="d-flex justify-content-center gap-3">
                  {/* <Button
                    variant="danger"
                    onClick={() =>
                      modal.showConfirmation({
                        title: `${localize.getText("areYouSure")}?`,
                        message: localize.getText("messageDeleteData"),
                        onConfirm: () => mutateDelete(item.id),
                      })
                    }
                  >
                    <i class="fas fa-trash"></i>
                  </Button> */}
                  <Link
                    to={{
                      pathname: "/item/detail-item",
                      search: `?id=${item.id}`,
                    }}
                  >
                    <Button variant="warning">
                      <i class="fas fa-eye"></i>
                    </Button>
                  </Link>
                  <Link
                    to={{
                      pathname: "/item/edit-item",
                      search: `?id=${item.id}`,
                    }}
                  >
                    <Button variant="info">
                      <i class="fas fa-edit"></i>
                    </Button>
                  </Link>
                </div>
              </td>
            </tr>
          ))}
        </Table>
      </div>
    </div>
  );
}
